import { render } from "./PushNotifications.vue?vue&type=template&id=75527c91&scoped=true"
import script from "./PushNotifications.vue?vue&type=script&lang=js"
export * from "./PushNotifications.vue?vue&type=script&lang=js"

import "./PushNotifications.vue?vue&type=style&index=0&id=75527c91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75527c91"]])

export default __exports__